export enum MerchantsTransactionStatusEnum {
  ALL = 'All',
  REVISION = 'Revision',
  APPROVED = 'Approved',
  DENIED = 'Denied',
  RECEIPT = 'Receipt',
  EXECUTED = 'Executed',
  PENDING = 'Pending'
}
